const labInfo = {
  name: "Yapay Zeka ve Makine Öğrenmesi Laboratuvarı",
  location: "Kırşehir Ahi Evran Üniversitesi - Mühendislik-Mimarlık Fakültesi",
  description: "Arduino tabanlı sensör sistemleri, elektronik burun (electronic nose) uygulamaları, makine öğrenmesi ve derin öğrenme projeleri üzerine çalışmalar yürütülmektedir.",
  equipment: [
    "Arduino Mikrokontrolörler",
    "Sensör Sistemleri (Gaz, Sıcaklık, Nem)",
    "Elektronik Burun (Electronic Nose) Cihazları",
    "RF Sinyal Analiz Ekipmanları",
    "Geliştirme Kartları ve Modüller"
  ],
  researchAreas: [
    "IoT Cihaz Kimlik Tespiti",
    "Gıda Kalite Analizi",
    "RF Parmak İzi",
    "Makine Öğrenmesi Uygulamaları",
    "Derin Öğrenme Modelleri"
  ],
  contact: {
    email: "memduh.kose@ahievran.edu.tr",
    room: "Z-24",
    building: "Mühendislik-Mimarlık Fakültesi"
  }
};

export default labInfo;

